<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm-title">Abbreviations</h2>
<table class="table">
<tbody><tr>
<td><p class="tab1">A’s &amp; A’s</p></td>
<td><p class="tab">Alterations &amp; Additions</p></td>
</tr>
<tr>
<td><p class="tab1">A/A</p></td>
<td><p class="tab">anti-aircraft</p></td>
</tr>
<tr>
<td><p class="tab1">AC</p></td>
<td><p class="tab">Aircraft carrier; Assistant Constructor</p></td>
</tr>
<tr>
<td><p class="tab1">accom</p></td>
<td><p class="tab">accommodation</p></td>
</tr>
<tr>
<td><p class="tab1">ACNS</p></td>
<td><p class="tab">Assistant Chief of Naval Staff (H = home, F = foreign, W = weapons)</p></td>
</tr>
<tr>
<td><p class="tab1">AC(WP)</p></td>
<td><p class="tab">Assistant Controller (Warship Production)</p></td>
</tr>
<tr>
<td><p class="tab1">Admy</p></td>
<td><p class="tab">Admiralty</p></td>
</tr>
<tr>
<td><p class="tab1">ADNC</p></td>
<td><p class="tab">Assistant Director of Naval Construction</p></td>
</tr>
<tr>
<td><p class="tab1">AFD</p></td>
<td><p class="tab">Admiralty Floating Dock</p></td>
</tr>
<tr>
<td><p class="tab1">agin</p></td>
<td><p class="tab">against</p></td>
</tr>
<tr>
<td><p class="tab1">ANCXF</p></td>
<td><p class="tab">Allied Naval Commander Expeditionary Force</p></td>
</tr>
<tr>
<td><p class="tab1">AP</p></td>
<td><p class="tab">armour piercing</p></td>
</tr>
<tr>
<td><p class="tab1">app’d</p></td>
<td><p class="tab">approved</p></td>
</tr>
<tr>
<td><p class="tab1">appt</p></td>
<td><p class="tab">appointment</p></td>
</tr>
<tr>
<td><p class="tab1">AR</p></td>
<td><p class="tab">air raid</p></td>
</tr>
<tr>
<td><p class="tab1">armt</p></td>
<td><p class="tab">armament</p></td>
</tr>
<tr>
<td><p class="tab1">arrgt</p></td>
<td><p class="tab">arrangement</p></td>
</tr>
<tr>
<td><p class="tab1">AS</p></td>
<td><p class="tab">Admiral Superintendent</p></td>
</tr>
<tr>
<td><p class="tab1">A/S</p></td>
<td><p class="tab">anti-submarine</p></td>
</tr>
<tr>
<td><p class="tab1">ASCBS</p></td>
<td><p class="tab">Admiral Superintendent Contract Built Ships</p></td>
</tr>
<tr>
<td><p class="tab1">ASIs</p></td>
<td><p class="tab">Admiralty Supply Items</p></td>
</tr>
<tr>
<td><p class="tab1">BAD</p></td>
<td><p class="tab">British Admiralty Delegation (in USA)</p></td>
</tr>
<tr>
<td><p class="tab1">BATM</p></td>
<td><p class="tab">British Admiralty Technical Mission (in Canada)</p></td>
</tr>
<tr>
<td><p class="tab1">BC</p></td>
<td><p class="tab">British Corporation</p></td>
</tr>
<tr>
<td><p class="tab1">BDE</p></td>
<td><p class="tab">British destroyer escort (US-built)</p></td>
</tr>
<tr>
<td><p class="tab1">bkd</p></td>
<td><p class="tab">bulkhead</p></td>
</tr>
<tr>
<td><p class="tab1">blr</p></td>
<td><p class="tab">boiler</p></td>
</tr>
<tr>
<td><p class="tab1">BSRA</p></td>
<td><p class="tab">British Shipbuilding Research Association</p></td>
</tr>
<tr>
<td><p class="tab1">C in C</p></td>
<td><p class="tab">Commander in Chief</p></td>
</tr>
<tr>
<td><p class="tab1">C of S or COS</p></td>
<td><p class="tab">Chief of Staff</p></td>
</tr>
<tr>
<td><p class="tab1">C’tee</p></td>
<td><p class="tab"><a id="page_ix"></a>Committee</p></td>
</tr>
<tr>
<td><p class="tab1">CC</p></td>
<td><p class="tab">Chief Constructor</p></td>
</tr>
<tr>
<td><p class="tab1">CCO</p></td>
<td><p class="tab">Chief Combined Operations</p></td>
</tr>
<tr>
<td><p class="tab1">CE</p></td>
<td><p class="tab">Civil Establishments?</p></td>
</tr>
<tr>
<td><p class="tab1">C E in C</p></td>
<td><p class="tab">Civil Engineer in Chief</p></td>
</tr>
<tr>
<td><p class="tab1">Cl</p></td>
<td><p class="tab">Class</p></td>
</tr>
<tr>
<td><p class="tab1">CL</p></td>
<td><p class="tab">Cammell Laird; Controller of Labour?</p></td>
</tr>
<tr>
<td><p class="tab1">CMSR</p></td>
<td><p class="tab">Controller of Merchant Shipbuilding &amp; Repair</p></td>
</tr>
<tr>
<td><p class="tab1">CNC</p></td>
<td><p class="tab">Contact Non-Contact (torpedo)</p></td>
</tr>
<tr>
<td><p class="tab1">CO</p></td>
<td><p class="tab">Commanding officer; Combined Operations</p></td>
</tr>
<tr>
<td><p class="tab1">compt</p></td>
<td><p class="tab">compartment</p></td>
</tr>
<tr>
<td><p class="tab1">Contr</p></td>
<td><p class="tab">Controller</p></td>
</tr>
<tr>
<td><p class="tab1">CS</p></td>
<td><p class="tab">Cruiser Squadron</p></td>
</tr>
<tr>
<td><p class="tab1">D of C</p></td>
<td><p class="tab">Director of Contracts (and Purchase)</p></td>
</tr>
<tr>
<td><p class="tab1">D of D</p></td>
<td><p class="tab">Director of Dockyards</p></td>
</tr>
<tr>
<td><p class="tab1">D of P</p></td>
<td><p class="tab">Director of Plans</p></td>
</tr>
<tr>
<td><p class="tab1">DA/SW</p></td>
<td><p class="tab">Director of Anti-Submarine Warfare</p></td>
</tr>
<tr>
<td><p class="tab1">DC</p></td>
<td><p class="tab">Damage control; depth charge</p></td>
</tr>
<tr>
<td><p class="tab1">DCOM</p></td>
<td><p class="tab">Director Combined Operations Material</p></td>
</tr>
<tr>
<td><p class="tab1">DCT</p></td>
<td><p class="tab">Director control tower; depth-charge thrower</p></td>
</tr>
<tr>
<td><p class="tab1">DCW</p></td>
<td><p class="tab">Director of Contract Work</p></td>
</tr>
<tr>
<td><p class="tab1">DDNC</p></td>
<td><p class="tab">Deputy Director of Naval Construction</p></td>
</tr>
<tr>
<td><p class="tab1">DE</p></td>
<td><p class="tab">Destroyer escort</p></td>
</tr>
<tr>
<td><p class="tab1">DEE</p></td>
<td><p class="tab">Director of Electrical Engineering</p></td>
</tr>
<tr>
<td><p class="tab1">dept</p></td>
<td><p class="tab">department</p></td>
</tr>
<tr>
<td><p class="tab1">destr</p></td>
<td><p class="tab">destroyer</p></td>
</tr>
<tr>
<td><p class="tab1">DFSL</p></td>
<td><p class="tab">Deputy First Sea Lord</p></td>
</tr>
<tr>
<td><p class="tab1">DMB</p></td>
<td><p class="tab">Director Merchant Shipbuilding</p></td>
</tr>
<tr>
<td><p class="tab1">DMR</p></td>
<td><p class="tab">Director Merchant Ship Repair</p></td>
</tr>
<tr>
<td><p class="tab1">DMSR</p></td>
<td><p class="tab">Director Merchant Shipbuilding &amp; Repair</p></td>
</tr>
<tr>
<td><p class="tab1">DMWD</p></td>
<td><p class="tab">Department of Miscellaneous Weapon Development</p></td>
</tr>
<tr>
<td><p class="tab1">DNAD</p></td>
<td><p class="tab">Director of Naval Air Division</p></td>
</tr>
<tr>
<td><p class="tab1">DNC</p></td>
<td><p class="tab">Director of Naval Construction</p></td>
</tr>
<tr>
<td><p class="tab1">DNO</p></td>
<td><p class="tab">Director of Naval Ordnance</p></td>
</tr>
<tr>
<td><p class="tab1">D of D or DoD</p></td>
<td><p class="tab">Director of Dockyards</p></td>
</tr>
<tr>
<td><p class="tab1">D of S</p></td>
<td><p class="tab">Director of Stores</p></td>
</tr>
<tr>
<td><p class="tab1">DSC</p></td>
<td><p class="tab">Deputy Superintendent of Conversions?</p></td>
</tr>
<tr>
<td><p class="tab1">DSR</p></td>
<td><p class="tab">Director of Scientific Research</p></td>
</tr>
<tr>
<td><p class="tab1">DTM</p></td>
<td><p class="tab">Director of Torpedoes and Mining</p></td>
</tr>
<tr>
<td><p class="tab1">DTSD</p></td>
<td><p class="tab">Director of Training &amp; Staff Duties</p></td>
</tr>
<tr>
<td><p class="tab1">dwg</p></td>
<td><p class="tab">drawing</p></td>
</tr>
<tr>
<td><p class="tab1">DWP</p></td>
<td><p class="tab">Director of Warship Production</p></td>
</tr>
<tr>
<td><p class="tab1">E in C</p></td>
<td><p class="tab">Engineer in Chief</p></td>
</tr>
<tr>
<td><p class="tab1">ECF</p></td>
<td><p class="tab"><a id="page_x"></a>European cease fire</p></td>
</tr>
<tr>
<td><p class="tab1">EO</p></td>
<td><p class="tab">Engineer overseer or officer</p></td>
</tr>
<tr>
<td><p class="tab1">ERO</p></td>
<td><p class="tab">Emergency Repair Overseer</p></td>
</tr>
<tr>
<td><p class="tab1">exptl</p></td>
<td><p class="tab">experimental</p></td>
</tr>
<tr>
<td><p class="tab1">FAA</p></td>
<td><p class="tab">Fleet Air Arm</p></td>
</tr>
<tr>
<td><p class="tab1">FBC</p></td>
<td><p class="tab">Future Building Committee</p></td>
</tr>
<tr>
<td><p class="tab1">FOIC</p></td>
<td><p class="tab">Flag Officer in Charge</p></td>
</tr>
<tr>
<td><p class="tab1">FO(S) or FOS</p></td>
<td><p class="tab">Flag Officer, Submarines</p></td>
</tr>
<tr>
<td><p class="tab1">fwd</p></td>
<td><p class="tab">forward</p></td>
</tr>
<tr>
<td><p class="tab1">GM</p></td>
<td><p class="tab">Metacentric height, distance between metacentre (imaginary point of suspension) and centre of gravity. Needs to be positive i.e. G below M</p></td>
</tr>
<tr>
<td><p class="tab1">GMO</p></td>
<td><p class="tab">Gun mounting overseer</p></td>
</tr>
<tr>
<td><p class="tab1">H &amp; W</p></td>
<td><p class="tab">Harland &amp; Wolff</p></td>
</tr>
<tr>
<td><p class="tab1">HA</p></td>
<td><p class="tab">High angle. i.e. anti-aircraft</p></td>
</tr>
<tr>
<td><p class="tab1">HA/LA</p></td>
<td><p class="tab">High angle/low angle i.e. dual purpose guns</p></td>
</tr>
<tr>
<td><p class="tab1">HF</p></td>
<td><p class="tab">Home Fleet</p></td>
</tr>
<tr>
<td><p class="tab1">HL</p></td>
<td><p class="tab">Hawthorn Leslie</p></td>
</tr>
<tr>
<td><p class="tab1">HQ</p></td>
<td><p class="tab">Headquarters</p></td>
</tr>
<tr>
<td><p class="tab1">IAC</p></td>
<td><p class="tab">Intermediate aircraft carrier (light fleet carrier)</p></td>
</tr>
<tr>
<td><p class="tab1">INA</p></td>
<td><p class="tab">Institution of Naval Architects</p></td>
</tr>
<tr>
<td><p class="tab1">kn</p></td>
<td><p class="tab">knot(s)</p></td>
</tr>
<tr>
<td><p class="tab1">LCF</p></td>
<td><p class="tab">Landing Craft Flak (anti-aircraft)</p></td>
</tr>
<tr>
<td><p class="tab1">LCG</p></td>
<td><p class="tab">Landing Craft Gun (M = Medium)</p></td>
</tr>
<tr>
<td><p class="tab1">LCI(L)</p></td>
<td><p class="tab">Landing Craft Infantry (Large)</p></td>
</tr>
<tr>
<td><p class="tab1">LCT</p></td>
<td><p class="tab">Landing Craft Tank</p></td>
</tr>
<tr>
<td><p class="tab1">LFC</p></td>
<td><p class="tab">Light fleet carrier</p></td>
</tr>
<tr>
<td><p class="tab1">LR</p></td>
<td><p class="tab">Lloyd’s Register</p></td>
</tr>
<tr>
<td><p class="tab1">LST</p></td>
<td><p class="tab">Landing ship tank</p></td>
</tr>
<tr>
<td><p class="tab1">Lt</p></td>
<td><p class="tab">light</p></td>
</tr>
<tr>
<td><p class="tab1">M of WT</p></td>
<td><p class="tab">Ministry of War Transport</p></td>
</tr>
<tr>
<td><p class="tab1">MAC</p></td>
<td><p class="tab">Merchant aircraft carrier</p></td>
</tr>
<tr>
<td><p class="tab1">machy</p></td>
<td><p class="tab">machinery</p></td>
</tr>
<tr>
<td><p class="tab1">MBr</p></td>
<td><p class="tab">Military Branch (Admiralty department)</p></td>
</tr>
<tr>
<td><p class="tab1">MCD</p></td>
<td><p class="tab">Manager Constructive Department (at a dockyard)</p></td>
</tr>
<tr>
<td><p class="tab1">MGB</p></td>
<td><p class="tab">Motor gunboat</p></td>
</tr>
<tr>
<td><p class="tab1">MMS</p></td>
<td><p class="tab">Motor minesweeper</p></td>
</tr>
<tr>
<td><p class="tab1">mos</p></td>
<td><p class="tab">months</p></td>
</tr>
<tr>
<td><p class="tab1">M/S</p></td>
<td><p class="tab">Minesweeper</p></td>
</tr>
<tr>
<td><p class="tab1">M.S.</p></td>
<td><p class="tab">Merchant ship</p></td>
</tr>
<tr>
<td><p class="tab1">MTB</p></td>
<td><p class="tab">Motor torpedo boat</p></td>
</tr>
<tr>
<td><p class="tab1">mtg</p></td>
<td><p class="tab">mounting</p></td>
</tr>
<tr>
<td><p class="tab1">NA</p></td>
<td><p class="tab">Naval Attaché; naval architect; naval assistant</p></td>
</tr>
<tr>
<td><p class="tab1">NC</p></td>
<td><p class="tab">New construction; non cemented (armour); non-contact?</p></td>
</tr>
<tr>
<td><p class="tab1">NE</p></td>
<td><p class="tab"><a id="page_xi"></a>North-east</p></td>
</tr>
<tr>
<td><p class="tab1">NO</p></td>
<td><p class="tab">Naval officer</p></td>
</tr>
<tr>
<td><p class="tab1">No.</p></td>
<td><p class="tab">number</p></td>
</tr>
<tr>
<td><p class="tab1">NOIC</p></td>
<td><p class="tab">Naval Officer in Charge</p></td>
</tr>
<tr>
<td><p class="tab1">OB</p></td>
<td><p class="tab">Outer bottom; Ordnance Board</p></td>
</tr>
<tr>
<td><p class="tab1">OF</p></td>
<td><p class="tab">Oil fuel</p></td>
</tr>
<tr>
<td><p class="tab1">PA</p></td>
<td><p class="tab">Public Accounts</p></td>
</tr>
<tr>
<td><p class="tab1">PBr</p></td>
<td><p class="tab">Priority Branch (Admiralty department)</p></td>
</tr>
<tr>
<td><p class="tab1">P.M.</p></td>
<td><p class="tab">Prime Minister; post meridiem</p></td>
</tr>
<tr>
<td><p class="tab1">Prog</p></td>
<td><p class="tab">Programme</p></td>
</tr>
<tr>
<td><p class="tab1">PSO</p></td>
<td><p class="tab">Principal Ship Overseer</p></td>
</tr>
<tr>
<td><p class="tab1">pts</p></td>
<td><p class="tab">points</p></td>
</tr>
<tr>
<td><p class="tab1">RA(D)</p></td>
<td><p class="tab">Rear Admiral (Destroyers)</p></td>
</tr>
<tr>
<td><p class="tab1">RA(S) or RAS</p></td>
<td><p class="tab">Rear Admiral Submarines</p></td>
</tr>
<tr>
<td><p class="tab1">RCNC</p></td>
<td><p class="tab">Royal Corps of Naval Constructors</p></td>
</tr>
<tr>
<td><p class="tab1">RDF</p></td>
<td><p class="tab">Radio direction finding (radar)</p></td>
</tr>
<tr>
<td><p class="tab1">RNVR</p></td>
<td><p class="tab">Royal Naval Volunteer Reserve</p></td>
</tr>
<tr>
<td><p class="tab1">RPC</p></td>
<td><p class="tab">Remote Power Control</p></td>
</tr>
<tr>
<td><p class="tab1">RY</p></td>
<td><p class="tab">Royal Yacht</p></td>
</tr>
<tr>
<td><p class="tab1">S of C</p></td>
<td><p class="tab">Superintendent of Conversions</p></td>
</tr>
<tr>
<td><p class="tab1">S/M</p></td>
<td><p class="tab">Submarine</p></td>
</tr>
<tr>
<td><p class="tab1">SCW</p></td>
<td><p class="tab">Superintendent of Contract Work</p></td>
</tr>
<tr>
<td><p class="tab1">Sec</p></td>
<td><p class="tab">Secretary</p></td>
</tr>
<tr>
<td><p class="tab1">SGB</p></td>
<td><p class="tab">Steam gunboat</p></td>
</tr>
<tr>
<td><p class="tab1">SH</p></td>
<td><p class="tab">Swan Hunter (&amp; Wigham Richardson)</p></td>
</tr>
<tr>
<td><p class="tab1">SL</p></td>
<td><p class="tab">Sea Lord</p></td>
</tr>
<tr>
<td><p class="tab1">SLC</p></td>
<td><p class="tab">Superintendent of Landing Craft</p></td>
</tr>
<tr>
<td><p class="tab1">SO</p></td>
<td><p class="tab">Senior officer</p></td>
</tr>
<tr>
<td><p class="tab1">SYDC</p></td>
<td><p class="tab">Shipyard Development Committee</p></td>
</tr>
<tr>
<td><p class="tab1">TF</p></td>
<td><p class="tab">Transport ferry i.e. LST</p></td>
</tr>
<tr>
<td><p class="tab1">T G</p></td>
<td><p class="tab">Thank God</p></td>
</tr>
<tr>
<td><p class="tab1">TLC</p></td>
<td><p class="tab">Tank landing craft (later LCT)</p></td>
</tr>
<tr>
<td><p class="tab1">USN</p></td>
<td><p class="tab">United States Navy</p></td>
</tr>
<tr>
<td><p class="tab1">USS</p></td>
<td><p class="tab">United States Ship</p></td>
</tr>
<tr>
<td><p class="tab1">UXB</p></td>
<td><p class="tab">Unexploded bomb</p></td>
</tr>
<tr>
<td><p class="tab1">v</p></td>
<td><p class="tab">very or versus</p></td>
</tr>
<tr>
<td><p class="tab1">V-A</p></td>
<td><p class="tab">Vickers-Armstrongs</p></td>
</tr>
<tr>
<td><p class="tab1">VCNS</p></td>
<td><p class="tab">Vice Chief of Naval Staff</p></td>
</tr>
<tr>
<td><p class="tab1">v.g.</p></td>
<td><p class="tab">very good</p></td>
</tr>
<tr>
<td><p class="tab1">WPS</p></td>
<td><p class="tab">Warship Production Superintendent</p></td>
</tr>
<tr>
<td><p class="tab1">wt</p></td>
<td><p class="tab">weight</p></td>
</tr>
<tr>
<td><p class="tab1">WT</p></td>
<td><p class="tab">Watertight; watertube (boilers)</p></td>
</tr>
<tr>
<td><p class="tab1">W/T</p></td>
<td><p class="tab">Wireless telegraphy</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?617840d9